var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Essentional, UI / Close Circle",
    clipPath: "url(#clip0_5162_1914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68654 5.97975C6.49128 5.78449 6.1747 5.78449 5.97943 5.97975C5.78417 6.17501 5.78417 6.49159 5.97943 6.68686L7.29255 7.99998L5.97945 9.31308C5.78419 9.50835 5.78419 9.82493 5.97945 10.0202C6.17471 10.2155 6.49129 10.2155 6.68656 10.0202L7.99966 8.70708L9.31275 10.0202C9.50802 10.2154 9.8246 10.2154 10.0199 10.0202C10.2151 9.82491 10.2151 9.50833 10.0199 9.31307L8.70677 7.99998L10.0199 6.68687C10.2151 6.49161 10.2151 6.17503 10.0199 5.97976C9.82461 5.7845 9.50803 5.7845 9.31277 5.97976L7.99966 7.29287L6.68654 5.97975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 0.833313C4.04163 0.833313 0.833008 4.04194 0.833008 7.99998C0.833008 11.958 4.04163 15.1666 7.99967 15.1666C11.9577 15.1666 15.1663 11.958 15.1663 7.99998C15.1663 4.04194 11.9577 0.833313 7.99967 0.833313ZM1.83301 7.99998C1.83301 4.59422 4.59392 1.83331 7.99967 1.83331C11.4054 1.83331 14.1663 4.59422 14.1663 7.99998C14.1663 11.4057 11.4054 14.1666 7.99967 14.1666C4.59392 14.1666 1.83301 11.4057 1.83301 7.99998Z",
    fill: "#EF4444"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5162_1914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reject.0f5f75b556339a4d6c819b531216f7e1.svg";